import { render, staticRenderFns } from "./informationStatutory.vue?vue&type=template&id=30edb637&scoped=true&"
import script from "./informationStatutory.vue?vue&type=script&lang=js&"
export * from "./informationStatutory.vue?vue&type=script&lang=js&"
import style0 from "./informationStatutory.vue?vue&type=style&index=0&id=30edb637&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30edb637",
  null
  
)

export default component.exports